module.exports = __webpack_public_path__ + "img/TheEducationView.5564e97b.jpg";